import React, { Component } from 'react'
import DigitalSidebar from './DigitalSidebar'
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';

export default class OpenAccessResources extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Digital Library" image="banner/library-3.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header" style={{ borderTopColor: "red" }}>
                      <h4 className="title">Open Access E-Resources</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead style={{ backgroundColor: "#98002e", color: "white" }}>
                      <tr>
                        <th scope="col">SL No</th>
                        <th scope="col">Name of Online Resources</th>
                        <th scope="col">Website Address</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>National Digital Library of India (NDLI)</td>
                        <td><a href='https://ndl.iitkgp.ac.in' target="_blank">https://ndl.iitkgp.ac.in</a></td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>Directory of Open Access Journals (DOAJ)</td>
                        <td><a href='https://doaj.org' target="_blank">https://doaj.org</a></td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>Directory of Open Access Books</td>
                        <td><a href='https://www.doabooks.org' target="_blank">https://www.doabooks.org</a></td>
                      </tr>
                      <tr>
                        <td>04</td>
                        <td>National Programme on Technology Enhanced Learning (NPTEL)</td>
                        <td><a href='https://nptel.ac.in' target="_blank">https://nptel.ac.in/</a></td>
                      </tr>
                      <tr>
                        <td>05</td>
                        <td>Shodhganga-a reservoir of Indian theses</td>
                        <td><a href='https://shodhganga.inflibnet.ac.in' target="_blank">https://shodhganga.inflibnet.ac.in</a></td>
                      </tr>
                      <tr>
                        <td>06</td>
                        <td>e-PG Pathshala</td>
                        <td><a href='https://epgp.inflibnet.ac.in' target="_blank">https://epgp.inflibnet.ac.in</a></td>
                      </tr>
                      <tr>
                        <td>07</td>
                        <td>Open Access Thesis & Dissertations</td>
                        <td><a href='https://oatd.org' target="_blank">https://oatd.org</a></td>
                      </tr>
                      <tr>
                        <td>08</td>
                        <td>Open Knowledge Repository - World Bank</td>
                        <td><a href='https://openknowledge.worldbank.org' target="_blank">https://openknowledge.worldbank.org</a></td>
                      </tr>
                      <tr>
                        <td>09</td>
                        <td>Legal Information Institute of India</td>
                        <td><a href='http://liiofindia.org' target="_blank">http://liiofindia.org</a></td>
                      </tr>
                      <tr>
                        <td>10</td>
                        <td>The OAPEN Foundation</td>
                        <td><a href='http://www.oapen.org/content' target="_blank">http://www.oapen.org/content</a></td>
                      </tr>
                      <tr>
                        <td>11</td>
                        <td>PubMed Central (PMC)</td>
                        <td><a href='https://www.ncbi.nlm.nih.gov/pmc/?cmd=search&term=' target="_blank">https://www.ncbi.nlm.nih.gov/pmc/?cmd=search&term=</a></td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>Project Gutenberg</td>
                        <td><a href='https://dev.gutenberg.org' target="_blank">https://dev.gutenberg.org</a></td>
                      </tr>
                      <tr>
                        <td>13</td>
                        <td>HighWire</td>
                        <td><a href='https://www.highwirepress.com' target="_blank">https://www.highwirepress.com</a></td>
                      </tr>
                      <tr>
                        <td>14</td>
                        <td>Southern Connecticut State University</td>
                        <td><a href='https://libguides.southernct.edu/openaccess' target="_blank">https://libguides.southernct.edu/openaccess</a></td>
                      </tr>
                      <tr>
                        <td>15</td>
                        <td>AGRIS</td>
                        <td><a href='http://agris.fao.org/agris-search/index.do' target="_blank">http://agris.fao.org/agris-search/index.do</a></td>
                      </tr>
                      <tr>
                        <td>16</td>
                        <td>Science Direct Open Access Content</td>
                        <td><a href='https://www.sciencedirect.com/#open-access' target="_blank">https://www.sciencedirect.com/#open-access</a></td>
                      </tr>
                      <tr>
                        <td>17</td>
                        <td>Aid Data</td>
                        <td><a href='https://www.aiddata.org' target="_blank">https://www.aiddata.org</a></td>
                      </tr>
                      <tr>
                        <td>18</td>
                        <td>ILOSTAT</td>
                        <td><a href='https://ilostat.ilo.org/' target="_blank">https://ilostat.ilo.org/</a></td>
                      </tr>
                      <tr>
                        <td>19</td>
                        <td>Oxford Open</td>
                        <td><a href='https://academic.oup.com/journals/pages/open_access' target="_blank">https://academic.oup.com/journals/pages/open_access</a></td>
                      </tr>
                      <tr>
                        <td>20</td>
                        <td>Project Euclid</td>
                        <td><a href='https://www.projecteuclid.org/librarians/lib_oa' target="_blank">https://www.projecteuclid.org/librarians/lib_oa</a></td>
                      </tr>
                      <tr>
                        <td>21</td>
                        <td>Springer Open Journals</td>
                        <td><a href='https://www.springeropen.com/journals' target="_blank">https://www.springeropen.com/journals</a></td>
                      </tr>
                      <tr>
                        <td>22</td>
                        <td>Taylor & Francis Open Access</td>
                        <td><a href='https://www.tandfonline.com/openaccess/openjournals' target="_blank">https://www.tandfonline.com/openaccess/openjournals</a></td>
                      </tr>
                      <tr>
                        <td>23</td>
                        <td>Cambridge University Press</td>
                        <td><a href='https://www.cambridge.org/core/what-we-publish/open-access' target="_blank">https://www.cambridge.org/core/what-we-publish/open-access</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DigitalSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
